'use client'
import React, { useState } from 'react'
import { Input } from '@/components/ui/input'
import { useRouter } from 'next/navigation'
import { Search, Loader2 } from 'lucide-react'
import { getParamsAsDict, generateFilterUrl } from '@/library/utils/params'

export default function SearchInput(props) {
  const { rootUrl, params } = props
  const paramsDict = getParamsAsDict(params.filters)
  const router = useRouter()
  const [searchValue, setSearchValue] = useState(paramsDict.query || '')
  const [isFocused, setIsFocused] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e) => {
    setSearchValue(e.target.value)
  }

  const handleOnBlur = () => {
    setIsFocused(false)
    if (searchValue) {
      setIsLoading(true)
    }
    const paramsDict = getParamsAsDict(params.filters)
    const newParams = { ...paramsDict, query: searchValue, page: 1 }
    const filterUrl = generateFilterUrl(newParams, rootUrl)
    router.push(filterUrl)
  }

  return (
    <div className="relative">
      {isLoading ? (
        <Loader2 className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground animate-spin" />
      ) : (
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      )}
      <Input
        type="search"
        placeholder="Search..."
        className={`pl-8 transition-all duration-200 ${isFocused ? 'w-[300px]' : 'w-[120px]'}`}
        value={searchValue}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={handleOnBlur}
        disabled={isLoading}
      />
    </div>
  )
}
